import SecureLS from 'secure-ls'
const secureLsInstanze = new SecureLS({
  encodingType: 'des',
  isCompression: true,
  encryptionSecret: 'p(xt/5^gMe;6deTP'
})

export default {
  methods: {
    lsGetItem(key) {
      return secureLsInstanze.get(key)
    },
    lsSetItem(key, value) {
      secureLsInstanze.set(key, value)
    },
    lsRemoveItem(key) {
      secureLsInstanze.remove(key)
    }
  }
}
